<template>
  <v-card>
    <v-card-text>
      <h3>Weight</h3>
      <convert-box></convert-box>
    </v-card-text>
  </v-card>
</template>

<script>
import ConvertBox from '../components/ConvertBox'

export default {
  components: { ConvertBox },
  data() {
    return {
      unit: [
        {
          text: 'Kilogram',
          val: 1
        },
        {
          text: 'Gram',
          val: 1000
        },
        {
          text: 'Milligram',
          val: 1000000
        },
        {
          text: 'Metric Ton',
          val: 0.001
        },
        {
          text: 'Long Ton',
          val: 0.0009842073
        },
        {
          text: 'Short Ton',
          val: 0.0011023122
        },
        {
          text: 'Pound',
          val: 2.2046244202
        },
        {
          text: 'Ounce',
          val: 35.273990723
        },
        {
          text: 'Carrat',
          val: 5000
        },
        {
          text: 'Atomic Mass Unit',
          val: 6.022136652e26
        }
      ]
    }
  },
  created() {
    this.$store.dispatch('setUnit', this.unit)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// weight.vue?7e799302